var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 15.5455V14.6364C26.6667 13.3635 26.6667 12.7271 26.4244 12.2409C26.2114 11.8133 25.8714 11.4656 25.4533 11.2477C24.978 11 24.3557 11 23.1111 11H13.5556C12.311 11 11.6887 11 11.2134 11.2477C10.7952 11.4656 10.4553 11.8133 10.2422 12.2409C10 12.7271 10 13.3635 10 14.6364V15.5455M10 15.5455V25.5455C10 26.8183 10 27.4548 10.2422 27.9409C10.4553 28.3685 10.7952 28.7162 11.2134 28.9341C11.6887 29.1818 12.311 29.1818 13.5556 29.1818H26.4444C27.689 29.1818 28.3113 29.1818 28.7867 28.9341C29.2048 28.7162 29.5448 28.3685 29.7578 27.9409C30 27.4548 30 26.8183 30 25.5455V19.1818C30 17.909 30 17.2725 29.7578 16.7864C29.5448 16.3587 29.2048 16.0111 28.7867 15.7932C28.3113 15.5455 27.689 15.5455 26.4444 15.5455H10ZM30 20.0909H27.7778C26.5504 20.0909 25.5556 21.1084 25.5556 22.3636C25.5556 23.6189 26.5504 24.6364 27.7778 24.6364H30",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.e41c2101145732c8650487642426d560.svg";
export { ForwardRef as ReactComponent };